import { Modal, Container, Dialog, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import { useEffect, useState } from 'react'
import { useManosStore } from './hooks'


const GoBack = ({isMobile}) => {
    const { zoomArcade, setCloseArcade, setInstructionsClosed } = useManosStore()
    const [openModal, setOpenModal] = useState(false)

    useEffect(() => {
        if (zoomArcade && !isMobile) {
            setTimeout(() => {
                setOpenModal(zoomArcade)
            }, 500)
        }
    }, [zoomArcade,isMobile])

    const handleCloseDialog = () => {
        setOpenModal(false)
        setInstructionsClosed(true)
    }

    const handleGoBack = () => {
        setCloseArcade(true)
        setInstructionsClosed(false)
    }

    return <>
        <Dialog open={openModal} onClose={handleCloseDialog} PaperProps={{ style: { background: 'transparent', border: '1px solid #fff' }, elevation: 0 }}>
            <Stack style={{ alignItems: 'center', justifyContent: 'center' }}>
                <img src='/assets/keys.png' width="500" />
                <Typography variant='caption' color={'#fff'} style={{ cursor: 'pointer' }} onClick={handleCloseDialog}>*Click to hide</Typography>
            </Stack>
        </Dialog>
        <div style={{ position: 'absolute', right: 10, bottom: 10, height: 100, zIndex: 9000 }} onTouchStart={handleGoBack} onClick={handleGoBack}>
            <h3 className='pixel' style={{ cursor: 'pointer' }}>{zoomArcade ? 'Go Back' : ''}</h3>
        </div>
    </>
}

export default GoBack